import { createShowferPlayer } from "./ShowferPlayer";

export default createShowferPlayer();